import { IPagination } from 'app/types/common';

export interface IOrganisationSectionsState {
  readonly organisationSectionsById?: any;
  readonly organisationSectionIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrganisationSectionLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrganisationSection?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrganisationSectionIds?: string[];
  readonly currentOrganisationSectionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationSectionsSelector
  extends IOrganisationSectionsState {
  readonly currentOrganisationSection?: any;
  readonly currentFormOrganisationSection?: any;
  readonly organisationSectionsFilteredByOrganisationInSelectFormat?: any;
  readonly organisationSectionsByTagAndIdInSelectFormat?: any;
  readonly organisationSectionsByIdInSelectFormat?: any;
  readonly organisationSectionsFilteredByCompetitionInSelectFormat?: any;
  readonly organisationSectionsFilteredByIdInSelectFormat?: any;
}

export enum OrganisationSectionsActionTypes {
  GET_ALL_ORGANISATION_SECTIONS_REQUESTED = 'redux-app/organisation-sections/GET_ALL_ORGANISATION_SECTIONS_REQUESTED',
  GET_ALL_ORGANISATION_SECTIONS_PENDING = 'redux-app/organisation-sections/GET_ALL_ORGANISATION_SECTIONS_PENDING',
  GET_ALL_ORGANISATION_SECTIONS_SUCCESS = 'redux-app/organisation-sections/GET_ALL_ORGANISATION_SECTIONS_SUCCESS',
  GET_ALL_ORGANISATION_SECTIONS_FAIL = 'redux-app/organisation-sections/GET_ALL_ORGANISATION_SECTIONS_FAIL',
  GET_ORGANISATION_SECTION_REQUESTED = 'redux-app/organisation-sections/GET_ORGANISATION_SECTION_REQUESTED',
  GET_ORGANISATION_SECTION_PENDING = 'redux-app/organisation-sections/GET_ORGANISATION_SECTION_PENDING',
  GET_ORGANISATION_SECTION_SUCCESS = 'redux-app/organisation-sections/GET_ORGANISATION_SECTION_SUCCESS',
  GET_ORGANISATION_SECTION_FAIL = 'redux-app/organisation-sections/GET_ORGANISATION_SECTION_FAIL',
  UPDATE_ORGANISATION_SECTION_REQUESTED = 'redux-app/organisation-sections/UPDATE_ORGANISATION_SECTION_REQUESTED',
  UPDATE_ORGANISATION_SECTION_PENDING = 'redux-app/organisation-sections/UPDATE_ORGANISATION_SECTION_PENDING',
  UPDATE_ORGANISATION_SECTION_SUCCESS = 'redux-app/organisation-sections/UPDATE_ORGANISATION_SECTION_SUCCESS',
  UPDATE_ORGANISATION_SECTION_FAIL = 'redux-app/organisation-sections/UPDATE_ORGANISATION_SECTION_FAIL',
  CREATE_ORGANISATION_SECTION_REQUESTED = 'redux-app/organisation-sections/CREATE_ORGANISATION_SECTION_REQUESTED',
  CREATE_ORGANISATION_SECTION_PENDING = 'redux-app/organisation-sections/CREATE_ORGANISATION_SECTION_PENDING',
  CREATE_ORGANISATION_SECTION_SUCCESS = 'redux-app/organisation-sections/CREATE_ORGANISATION_SECTION_SUCCESS',
  CREATE_ORGANISATION_SECTION_FAIL = 'redux-app/organisation-sections/CREATE_ORGANISATION_SECTION_FAIL',
  DELETE_ORGANISATION_SECTION_REQUESTED = 'redux-app/organisation-sections/DELETE_ORGANISATION_SECTION_REQUESTED',
  DELETE_ORGANISATION_SECTION_PENDING = 'redux-app/organisation-sections/DELETE_ORGANISATION_SECTION_PENDING',
  DELETE_ORGANISATION_SECTION_SUCCESS = 'redux-app/organisation-sections/DELETE_ORGANISATION_SECTION_SUCCESS',
  DELETE_ORGANISATION_SECTION_FAIL = 'redux-app/organisation-sections/DELETE_ORGANISATION_SECTION_FAIL',
  SELECT_ORGANISATION_SECTION_REQUESTED = 'redux-app/organisation-sections/SELECT_ORGANISATION_SECTION_REQUESTED',
}

export default null;
